import React, { useEffect, useState } from 'react';
import { Layout, Popconfirm, message, Button, Table, Space } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import MemberSidebar from './components/member.sidebar.component';
import MemberFooter from './components/member.footer.component';
import { useDispatch } from 'react-redux';
import { readTripCountries, deleteTripCountry } from '../actions/entity.trip.country';
import { PageHeader } from '@ant-design/pro-components';
import { useTranslation } from 'react-i18next';

function TripCountries(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const { Content } = Layout;
    const [dataSource, setDataSource] = useState([]);

    const deleteTripCountryAction = (id) => {
        dispatch(deleteTripCountry(params.entityId, id)).then((response) => {
            message.success(t('entities.message.delete-success'));
            setDataSource(dataSource.filter(item => item.id !== id));
        }).catch(e => {
            console.log(e);
            message.error(t('entities.message.delete-failed'));
        });
    }

    const columns = [
        {
            title: t('tripCountries.columns.slug'),
            dataIndex: 'slug',
            key: 'slug',
        },
        {
            title: t('tripCountries.columns.status'),
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                if (typeof record.status !== 'undefined' && record.status === true) {
                    return t('tripCountries.columns.status.enabled');
                } else {
                    return t('tripCountries.columns.status.disabled');
                }
            }
        },
        {
            title: t('tripCountries.columns.created'),
            dataIndex: 'createdAt',
            key: 'createdAt'
        },
        {
            title: t('tripCountries.columns.actions'),
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => <Space>
                <Button size="small" type="primary" href={`/entity/${params.entityId}/trip-country/${record.id}`}>{t('tripCountries.actions.edit')}</Button>
                <Popconfirm
                    title={t('tripCountries.actions.delete-confirm')}
                    onConfirm={() => deleteTripCountryAction(record.id)}
                    okText={t('tripCountries.actions.delete-ok')}
                    cancelText={t('tripCountries.actions.delete-cancel')}
                >
                    <Button size="small" type="primary" danger>{t('tripCountries.actions.delete')}</Button>
                </Popconfirm>
            </Space>

        }
    ];

    useEffect(() => {
        dispatch(readTripCountries(params.entityId)).then((response) => {
            if (typeof response.result !== 'undefined') {
                setDataSource(response.result);
            } else {
                setDataSource([]);
            }
        }).catch((error) => {
            try {
                setDataSource([]);
                let responseMessage = error.response.data.message;
                console.log(responseMessage);
                message.error(responseMessage);
            } catch (e) {
                console.log('Failed:', e);
                message.error(JSON.stringify(e));
            }
        });
    }, [dispatch, params.entityId]);

    return <>
        <MemberSidebar />
        <Layout className="site-layout">
            <Content style={{ margin: '0 16px' }}>
                <div className="site-layout-background">
                    <PageHeader
                        className="site-page-header"
                        onBack={() => navigate(`/entity/${params.entityId}/dashboard`)}
                        title={t('tripCountries.title')}
                        subTitle={t('tripCountries.subtitle')}
                        extra={[
                            <Button key="create" type="primary" href={`/entity/${params.entityId}/trip-country`}>{t('tripCountries.actions.new')}</Button>
                        ]}
                    />
                    <Table
                        size='small'
                        rowKey={record => record.id}
                        dataSource={dataSource}
                        columns={columns} />
                </div>
            </Content>
            <MemberFooter />
        </Layout>
    </>;
}

export default TripCountries;